import { ActionType } from "../interfaces/api/actionType";

export const GetCompetences: ActionType = {
  FAILURE: "GET_COMPETENCES_FAILURE",
  REQUEST: "GET_COMPETENCES_REQUEST",
  SUCCESS: "GET_COMPETENCES_SUCCESS",
};
